// 子 side bar 顯示位置 (業績報表/諮詢師業績/訂單業績明細/個人分潤/評論分析...etc)
// 以下註解若打開，前端頁面將會顯示該頁面，惟須注意後端返回資料名稱是否與以下 title 文字一致，否則點擊進入的權限可能會阻擋

export const menuBarList = {
  // "數據" 中的子 side bar
  statistics: [
    {
      label: "statistics",
      items: [
        {
          title: "業績報表",
          eng: "performanceReport",
          icon: "performanceReport",
        },
        {
          title: "虛擬業績報表",
          eng: "virtualPerformanceReport",
          icon: "performanceReport-outline",
        },
      ],
    },
    {
      label: "statistics",
      items: [
        {
          title: "核銷明細報表",
          eng: "verificationReport",
          icon: "verificationReport",
        },
        {
          title: "回饋金/點數管理報表",
          eng: "ledgerReport",
          icon: "verificationReport",
        },
      ],
    },
    {
      label: "statistics",
      items: [
        {
          title: "諮詢師業績",
          eng: "consultantPerformance",
          icon: "personal",
        },
        {
          title: "訂單業績明細", // 後端目前字段是 "個人業績"，應該要改成 "訂單業績明細"
          eng: "orderPerformanceDetails",
          icon: "performancesetting",
        },
        {
          title: "個人分潤",
          eng: "personalProfit",
          icon: "personal-profit-bar",
        },
        {
          title: "業績獎金級距試算",
          eng: "performanceBonusTrial",
          icon: "performancesetting",
        },
        // {
        //   title: "評論分析",
        //   eng: "commentAnalysis",
        //   icon: "commentAnalysis",
        // },
        // {
        //   title: "業績分潤設定",
        //   eng: "performancesetting",
        //   icon: "performancesetting",
        // },
        // {
        //   title: "業績分潤設定",
        //   eng: "personal",
        //   icon: "performancesetting",
        // },
      ],
    },
  ],
  // "班表" 中的子 side bar
  shiftschedule: [
    {
      label: "shiftschedule",
      items: [
        {
          title: "團隊成員",
          eng: "employees",
          icon: "employees",
        },
        {
          title: "經紀人",
          eng: "broker",
          icon: "broker",
        },
        {
          title: "班別設定",
          displayTitle: "設定班別",
          eng: "shifts",
          icon: "shifts",
        },
        {
          title: "班表管理",
          displayTitle: "管理班表",
          eng: "employeeshifts",
          icon: "employeeshifts",
        },
      ],
    },
    {
      label: "shiftschedule",
      items: [
        {
          title: "服務上架",
          displayTitle: "服務設定",
          eng: "service",
          icon: "services",
          groupOnly: true,
          show: false,
          label: "service",
          items: [
            {
              title: "服務上架",
              displayTitle: "服務上架管理",
              eng: "service",
            },
            {
              title: "分類管理",
              eng: "categorymanagement",
            },
            {
              title: "成本與分潤",
              eng: "service-cost",
            },
          ],
        },
      ],
    },
    {
      label: "shiftschedule",
      items: [
        {
          title: "術前同意書",
          eng: "consent-templates",
          icon: "intake-form-green",
          show: false,
          label: "consent",
          items: [
            {
              title: "範本設定",
              eng: "consent-templates",
            },
            {
              title: "對應服務分類",
              eng: "consent-category-link",
            },
            {
              title: "服務關聯設定",
              eng: "consent-service-link",
            },
          ],
        },
        {
          title: "付款同意書",
          eng: "payment-consent-template",
          icon: "intake-form-blue",
          show: false,
          label: "payment-consent",
          items: [
            {
              title: "範本設定",
              eng: "payment-consent-template",
            },
            {
              title: "對應服務分類",
              eng: "payment-consent-category-link",
            },
            {
              title: "服務關聯設定",
              eng: "payment-consent-service-link",
            },
          ],
        },
        {
          title: "療程後確認單",
          eng: "post-treatment-consent-template",
          icon: "intake-form-muted",
        },
        {
          title: "問卷單",
          eng: "questionnaire-templates",
          icon: "intake-form-green",
          show: false,
          label: "questionnaire",
          groupOnly: true,
          items: [
            {
              title: "範本設定",
              eng: "questionnaire-templates",
            },
            {
              title: "對應服務分類",
              eng: "questionnaire-category-link",
            },
            {
              title: "服務關聯設定",
              eng: "questionnaire-service-link",
            },
          ],
        },
      ],
    },
  ],
  // "會員" 中的子 side bar
  customer: [
    {
      label: "customer",
      items: [
        {
          title: "會員列表",
          eng: "list",
          icon: "bulksending",
        },
        {
          title: "初診單管理",
          eng: "intake-form",
          icon: "intake-profile-dark",
        },
        {
          title: "文件批次列印",
          eng: "document-batch-print",
          icon: "document-batch-print-dark",
        },
        {
          title: "簽署中心",
          eng: "signing-center",
          icon: "signing-center-dark",
        },
        {
          title: "發送訊息",
          eng: "bulksending",
          icon: "message-dark",
        },
      ],
    },
    {
      label: "customer",
      items: [
        {
          title: "轉贈紀錄",
          eng: "transfer",
          icon: "transfer",
        },
        {
          title: "換購紀錄",
          eng: "exchange",
          icon: "exchange",
        },
      ],
    },
  ],
  // Sidebar 我在這
  // "設定" 中的子 side bar
  options: [
    {
      label: "info",
      items: [
        {
          title: "公司資訊",
          eng: "company",
          icon: "company",
        },
        {
          title: "分店資訊",
          eng: "branch",
          icon: "branch",
        },
        {
          title: "診間設定",
          eng: "consulting",
          icon: "consulting",
        },
      ],
    },
    {
      label: "memberInteraction",
      items: [
        {
          title: "等級設定",
          eng: "member-management",
          icon: "member-management",
        },
        {
          title: "贈品規則",
          eng: "purchase-gift",
          icon: "member-management",
        },
        {
          title: "標籤管理",
          eng: "label",
          icon: "label",
          show: false,
        },
        // {
        //   title: "取消政策及訂金",
        //   eng: "cancellationpolicy",
        //   icon: "cancellation-policy",
        //   show: false,
        //   label: "cancellationpolicy",
        //   items: [
        //     {
        //       title: "取消政策設定",
        //       eng: "cancellationpolicysettings",
        //     },
        //     {
        //       title: "訂金管理",
        //       eng: "deposit",
        //     },
        //   ],
        // },
        {
          title: "訊息設定",
          eng: "message",
          icon: "message",
          show: false,
          label: "message",
          items: [
            {
              title: "自動化訊息設定",
              eng: "autoreply",
            },
            // {
            //   title: "發送訊息",
            //   eng: "bulksending",
            // },
            // {
            //   title: "訊息範本管理",
            //   eng: "messagetemplate",
            // },
          ],
        },
        {
          title: "初診單設定",
          eng: "intake-form",
          icon: "intake-profile",
        },
        {
          title: "病歷管理",
          eng: "medical-record",
          icon: "consent",
          show: false,
          label: "medicalRecord",
          groupOnly: true,
          items: [
            {
              title: "罐頭訊息",
              eng: "canned-message",
            },
            {
              title: "療程紀錄模板",
              eng: "treatment-record-templates",
            },
          ],
        },
      ],
    },
    // 20241206 隱藏子 side bar 的優惠管理
    {
      label: "discount",
      items: [
        // {
        //   title: "優惠管理",
        //   eng: "discountmanagement",
        //   icon: "discount-management",
        //   show: false,
        //   items: [
            // {
            //   title: "儲值金管理",
            //   eng: "topup",
            // },
            // {
            //   title: "品牌點數管理",
            //   eng: "point",
            // },
            // {
            //   title: "優惠券管理",
            //   eng: "coupon",
            // },
            // {
            //   title: "折扣管理",
            //   eng: "discount",
            // },
        //   ],
        // },
        {
          title: "POS付款/發票設定",
          eng: "pay",
          icon: "pay",
        },
      ],
    },
    {
      label: "account",
      items: [
        {
          title: "帳號權限管理",
          eng: "accountauthority",
          icon: "account-authority",
        },
        // {
        //   title: "POS付款/發票設定",
        //   eng: "pay",
        //   icon: "pay",
        // },
        // {
        //   title: "服務方案及繳款",
        //   eng: "serviceplan",
        //   icon: "service",
        // },
        // {
        //   title: "設定付款方式",
        //   eng: "setPaymentMethod",
        //   icon: "set-payment-method",
        // },
        {
          title: "API串接",
          eng: "payment-gateway",
          icon: "payment-flow",
        },
      ],
    },
    {
      label: "account",
      items: [
        {
          title: "喜好設定",
          eng: "preferences",
          icon: "set-payment-method-muted",
        },
        {
          title: "修改密碼",
          eng: "password",
          icon: "password",
        },
        // {
        //   title: "第三方工具整合",
        //   eng: "thirdparty",
        //   icon: "third-party",
        // },
        {
          title: "OBS 操作手冊",
          eng: "manual",
          icon: "manual",
        },
      ],
    },
  ],
  // "票券" 中的子 side bar
  tickets: [
    {
      label: "tickets",
      items: [
        // {
        //   title: "商品票券",
        //   eng: "commodity",
        //   icon: "account-authority",
        // },
        // {
        //   title: "活動票券",
        //   eng: "activity",
        //   icon: "service",
        // },
        {
          title: "課程管理",
          eng: "ticketManagement",
          icon: "payment-flow",
        },
        // 正式版暫關：卡項管理（直連另由 CLOSED_FEATURE_SUBPATHS 擋）
        // {
        //   title: "卡項管理",
        //   eng: "cardManagement",
        //   icon: "payment-flow",
        // },
      ],
    },
  ],
  // sales: [
  //   {
  //     label: "sales",
  //     items: [
  //       {
  //         title: "儲值金",
  //         eng: "topup",
  //         icon: "account-authority",
  //       },
  //     ],
  //   },
  // ],
};
